import React from "react";
import { ComboRateChart } from "src/components/common/chart/ComboRateChart";
import { PRD5020_R01ResultDto } from "./Dto_PRD5020_R01";

// Chart 컴포넌트가 받는 props 타입
interface Props {
	data: PRD5020_R01ResultDto[]; // 월별(1~12월) 결과 리스트
}

// 월별 성능가동율 콤보차트 컴포넌트 (막대 2개 + 선 1개 공용 컴포넌트 사용)
export const Chart_PRD5020_R01: React.FC<Props> = ({ data }) => {
	return (
		<ComboRateChart
			data={data}
			barSeries={[
				{ field: "optimalQty", label: "최적생산량", color: "#3B82F6" },
				{ field: "productQty", label: "생산량", color: "#FB923C" },
			]}
			lineSeries={{ field: "performanceRate", label: "성능가동율", color: "#22C55E" }}
		/>
	);
};
